var map = {
	"./DinaAndAdam-0325.webp": 206,
	"./IMG-0452.webp": 7940,
	"./batch_037A3645.webp": 4175,
	"./batch_813A1611.webp": 4414,
	"./batch_EinatMichael-0614.webp": 4810,
	"./batch_HadarAndRonen-0525.webp": 3526,
	"./batch_IMG-0280.webp": 9596,
	"./batch_IMG-0528.webp": 4771,
	"./batch_YahalomAndZvi-0636.webp": 421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1683;